import { configureStore } from '@reduxjs/toolkit';
import authReducer from './components/Auth/slice';
import loginReducer from './components/Login/slice';
import signupReducer from './components/SignUp/slice';
import jobsReducer from './components/Jobs/slice';
import profileReducer from './components/Profile/slice';

export default configureStore({
  reducer: {
    auth: authReducer,
    login: loginReducer,
    signup: signupReducer,
    jobs: jobsReducer,
    profile: profileReducer,
  },
});
